import React from 'react';
import { Logo } from './Logo';
import { Button } from './Button';
export function Navbar() {
  return <header className="sticky top-0 z-50 w-full border-b border-slate-200 bg-white/80 backdrop-blur-md" data-id="element-38" data-mp="jjaf1a1yhb65">
      <div className="container mx-auto px-4 h-16 flex items-center justify-between" data-id="element-39" data-mp="xa5i25prwy1t">
        <a href="#" className="focus:outline-none focus:ring-2 focus:ring-techblue rounded-sm" data-id="element-40" data-mp="saaqdzy6c4fp">
          <Logo data-id="element-41" data-mp="4lzulb7c4uya" />
        </a>

        <nav className="hidden md:flex items-center gap-8" data-id="element-42" data-mp="4naxl8syhyoc">
          <a href="#problema" className="text-sm font-medium text-slate-600 hover:text-navy transition-colors" data-id="element-43" data-mp="kobzpmvp9zl">
            Problema
          </a>
          <a href="#como-funciona" className="text-sm font-medium text-slate-600 hover:text-navy transition-colors" data-id="element-44" data-mp="9k1nsoyh6anh">
            Cómo funciona
          </a>
          <a href="#para-quien" className="text-sm font-medium text-slate-600 hover:text-navy transition-colors" data-id="element-45" data-mp="1kzzpu8v8jwf7">
            Para quién
          </a>
          <a href="#vision" className="text-sm font-medium text-slate-600 hover:text-navy transition-colors" data-id="element-46" data-mp="enanmlhupudy">
            Visión
          </a>
        </nav>

        <div className="flex items-center gap-4" data-id="element-47" data-mp="olqeqogvp3ng">
          <Button variant="ghost" className="hidden sm:inline-flex" data-id="element-48" data-mp="okfegymn6e13">
            Ver Ejemplo
          </Button>
          <Button variant="solid" data-id="element-49" data-mp="3n4xa0dez1m1y">Solicitar Demo</Button>
        </div>
      </div>
    </header>;
}